<template>
  <section class="company-page">
    <company-header :h1Content="h1Content" />
    <company-info :introContent="introContent" />
    <company-buttons :products="products" />
    <app-question-panel
      class="mt-16"
      :faqTitle="faqTitle"
      :faqTitleDesc="faqTitleDesc"
      :questions="questions"
    />
  </section>
</template>

<script>
import companyHeader from '@/component/company/CompanyHeader'
import companyInfo from '@/component/company/CompanyInfo'
import appQuestionPanel from '@/component/expansional-question-panel/AppQuestionPanel'
import companyButtons from '@/component/company/CompanyButtons'
import SompoSigortaData from '@/data/company-page-data/sompo-sigorta/SompoSigorta.js'

export default {
  metaInfo: {
    title: 'Sompo Sigorta Fiyatları İçin Teklif Alın, Karşılaştırın',
    meta: [
      {
        name: 'description',
        content:
          "Sompo Sigorta'dan fiyat teklifi alarak karşılaştırma yapın, en iyi sigorta planlarına online ulaşın. Sompo Sigorta Güvencesi ile poliçenizi satın alın."
      }
    ]
  },
  name: 'SompoSigorta',
  components: {
    companyHeader,
    companyInfo,
    appQuestionPanel,
    companyButtons
  },
  data () {
    return {
      h1Content: 'Sompo Sigorta Fiyatları',
      faqTitle: SompoSigortaData.faqTitle,
      faqTitleDesc: SompoSigortaData.faqTitleDesc,
      products: SompoSigortaData.products,
      introContent: SompoSigortaData.introContent,
      questions: SompoSigortaData.questions
    }
  }
}
</script>
